<template>
  <router-link :to="to(`/products/${solution.slug}`)" class="solution-card" :style="{ minHeight: `${minHeight}px` }">
    <div class="top">
      <span class="chip" :style="{ background: solution.chip }" aria-hidden="true"></span>
      <span class="arrow" aria-hidden="true">{{ arrow }}</span>
    </div>
    <div>
      <h3 class="card-title name" :style="{ fontSize: `${titleSize}px` }">{{ pick(solution, 'name') }}</h3>
      <p class="desc">{{ pick(solution, 'description') }}</p>
      <span v-if="pick(solution, 'audience')" class="tag">{{ pick(solution, 'audience') }}</span>
    </div>
  </router-link>
</template>

<script setup>
import { useLocale } from '../composables/useLocale'

defineProps({
  solution: { type: Object, required: true },
  minHeight: { type: Number, default: 270 },
  titleSize: { type: Number, default: 30 }
})

const { arrow, pick, to } = useLocale()
</script>

<style scoped>
.solution-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
  padding: 28px;
  background: var(--surface);
  border-radius: var(--radius-card);
  color: var(--ink);
  text-align: start;
  transition: background 0.2s ease;
}

.solution-card:hover {
  background: var(--surface-hover);
  color: var(--ink);
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.chip {
  width: 44px;
  height: 44px;
  border-radius: var(--radius-chip);
}

.arrow {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.name {
  margin-bottom: 10px;
}

.desc {
  font-size: 16px;
  line-height: 1.55;
  color: var(--muted);
  margin-bottom: 16px;
}
</style>
